const segurosAction = {
  CARROS_DTERCEROS: "CARROS_DTERCEROS",
  MOTOS_DTERCEROS: "MOTOS_DTERCEROS",
  DELETE_COMPLETED: "DELETE_COMPLETED",
  SELECT_COB_BASICA: "SELECT_COB_BASICA",
  SELECT_SEGURO_DT: "SELECT_SEGURO_DT",
  HASELECT_SEGURO_DT: "HASELECT_SEGURO_DT",
  SELECT_CARRO: "SELECT_CARRO",
  TIPO_COBERTURA: "TIPO_COBERTURA",
  ADD_QUOTE: "ADD_QUOTE",
  SEL_SEGURO: "SEL_SEGURO",
  SELECCION_SEGURO: "SELECCION_SEGURO",
  CONVERTIR_PDF: "CONVERTIR_PDF",
  SEL_LIMITES: "SEL_LIMITES",
  RES_QUOTE: "RES_QUOTE",
  SEL_SEGURO_CC: "SEL_SEGURO_CC",
  INTRERCOM_LISTO: "INTRERCOM_LISTO",
  NOT_SHOW_LANDING: "NOT_SHOW_LANDING",
  CEDULA_PASAPORTE: "CEDULA_PASAPORTE",
  SET_CURRENT_STEP: "SET_CURRENT_STEP",
  ARE_IN_FORM: "ARE_IN_FORM",
  SHOW_SPIN_FORM: "SHOW_SPIN_FORM",
  FORM_ERROR_MESSAGE: "FORM_ERROR_MESSAGE",
  ALLOW_PAYMENT_SUBMIT: "ALLOW_PAYMENT_SUBMIT",
  ALLOW_NEXT_STEP_FORM: "ALLOW_NEXT_STEP_FORM",
  STRIPE_FORM_COMPLETED: "STRIPE_FORM_COMPLETED",
  VALID_BORNDATE: "VALID_BORNDATE",
  CYBER_FORM_DATA: "CYBER_FORM_DATA",
  INDEX_LOADED: "INDEX_LOADED",
  CONTENT_LOADED: "CONTENT_LOADED",
  PAYMENT_MADE: "PAYMENT_MADE",
  DRIVER_FORM_WITHOUT_ERRORS: "DRIVER_FORM_WITHOUT_ERRORS",
  DRIVER_FORM_COMPLETED: "DRIVER_FORM_COMPLETED",
  FC_FORM_DRIVER_COMPLETED: "FC_FORM_DRIVER_COMPLETED",
  DRIVER_FORM_ID_COMPLETED: "DRIVER_FORM_ID_COMPLETED",
  VEHICLE_FORM_WITHOUT_ERRORS: "VEHICLE_FORM_WITHOUT_ERRORS",
  VEHICLE_FORM_COMPLETED: "VEHICLE_FORM_COMPLETED",
  ALLOW_CYBERPAYMENT: "ALLOW_CYBERPAYMENT",
  CYBER_FORM_COMPLETED: "CYBER_FORM_COMPLETED",
  PAY_FORM_COMPLETED: "PAY_FORM_COMPLETED",
  BOT_FORM_DRIVER_COMPLETED: "BOT_FORM_DRIVER_COMPLETED",
  BOT_FORM_VEHICLE_COMPLETED: "BOT_FORM_VEHICLE_COMPLETED",
  ARE_IN_BOT_FORM: "ARE_IN_BOT_FORM",
  PAY_CARD_TYPE: "PAY_CARD_TYPE",
  CYBER_POST_RESPONSE: "CYBER_POST_RESPONSE",
  EMISION_RESPONSE: "EMISION_RESPONSE",
  EMISION_ERROR_MESSAGE: "EMISION_ERROR_MESSAGE",
  REQUEST_CARS_API: "REQUEST_CARS_API",
  REQUEST_CYCLES_API: "REQUEST_CYCLES_API",
  REQUEST_USER_IP: "REQUEST_USER_IP",
  CARS_API_DATA: "CARS_API_DATA",
  CYCLES_API_DATA: "CYCLES_API_DATA",
  USER_IP: "USER_IP",
  EXPRESSPAYMENT_CYBER_FORM_DATA: "EXPRESSPAYMENT_CYBER_FORM_DATA",
  EXPRESSPAYMENT_FORM_COMPLETED: "EXPRESSPAYMENT_FORM_COMPLETED",
  EXPRESSPAYMENT_ERROR_MESSAGE: "EXPRESSPAYMENT_ERROR_MESSAGE",
  EXPRESSPAYMENT_CYBER_POST_RESPONSE: "EXPRESSPAYMENT_CYBER_POST_RESPONSE",
  EXPRESSPAYMENT_URL_PROPS: "EXPRESSPAYMENT_URL_PROPS",
  EXPRESSPAYMENT_BACKEND_RESPONSE: "EXPRESSPAYMENT_BACKEND_RESPONSE",
  EXPRESSPAYMENT_FULL_URL: "EXPRESSPAYMENT_FULL_URL",
  HAVE_POLICY_PIC: "HAVE_POLICY_PIC",
  EXPIRED_FORM_FILLED: "EXPIRED_FORM_FILLED",
  UNSUP_CARD_TYPE: "UNSUP_CARD_TYPE",
  OVERYEAR_VEHICLE: "OVERYEAR_VEHICLE",
  ADBLOCKER_DETECTED: "ADBLOCKER_DETECTED",
  SHOW_HOMEPAGE: "SHOW_HOMEPAGE",
  BANK_TRANSFER_PROCESS: "BANK_TRANSFER_PROCESS",
  YAPPY_TRANSFER_PROCESS: "YAPPY_TRANSFER_PROCESS",
  NOT_SHOW_POPUP: "NOT_SHOW_POPUP",
  RETURN_FROM_SAME_MODE: "RETURN_FROM_SAME_MODE",
  CYCLES_LANDING_MODE: "CYCLES_LANDING_MODE",
  CURRENT_REFERRER: "CURRENT_REFERRER",
  REFERRED_CODE: "REFERRED_CODE",
  FETCH_REFERRAL_QUOTE: "FETCH_REFERRAL_QUOTE",
  IS_FETCHING_REFERRAL_QUOTE: "IS_FETCHING_REFERRAL_QUOTE",
  SET_REFERRAL_QUOTE: "SET_REFERRAL_QUOTE",
  EMISION_WITH_SOAP_RESPONSE: "EMISION_WITH_SOAP_RESPONSE",
  BOT_FAIL_FORM_COMPLETED: "BOT_FAIL_FORM_COMPLETED",
  BOT_FAIL_FORM_USER_ID: "BOT_FAIL_FORM_USER_ID",
  DT_CUSTOMER_DATA_STORED: "DT_CUSTOMER_DATA_STORED",
  BOT_FAIL_FORM_EMISION_RESPONSE: "BOT_FAIL_FORM_EMISION_RESPONSE",
  REFERRAL_ID: "REFERRAL_ID",
  WTS_MODAL_USED: "WTS_MODAL_USED",
  BLACKLISTED_USER: "BLACKLISTED_USER",
  YAPPY_RESPONSE: "YAPPY_RESPONSE",
  FIRST_STEP_RELOADED: "FIRST_STEP_RELOADED",
  SELECTED_POLICY: "SELECTED_POLICY",
  RENEW_USER_ID: "RENEW_USER_ID",
  DT_CUSTOMER_IS_MOROSO: "DT_CUSTOMER_IS_MOROSO",
  DT_SET_RENEWAL_PLAN: "DT_SET_RENEWAL_PLAN",
  DT_SET_USE_TOKENIZATION: "DT_SET_USE_TOKENIZATION",
  INSURANCE_MODE: "INSURANCE_MODE",
  PAYMENT_MONTHLY_SKIP: "PAYMENT_MONTHLY_SKIP",
  RENEW_POLICY: "RENEW_POLICY",
  SET_RENEWED_POLICY: "SET_RENEWED_POLICY",
  IS_RENEWING_POLICY: "IS_RENEWING_POLICY",
  RENEW_POLICY_HAS_BEEN_CALLED: "RENEW_POLICY_HAS_BEEN_CALLED",
  POLICIES_MODAL_VISIBLE: "POLICIES_MODAL_VISIBLE",
  SETLOADING: "SETLOADING",
  REMOVELOADING: "REMOVELOADING",
  SET_POLICIE_EMITED_YAPPY: "SET_POLICIE_EMITED_YAPPY",
  SETRENEWALMONTHLYPAYMENT: "SETRENEWALMONTHLYPAYMENT",
  SETDTMONTHLYPAYMENT: "SETDTMONTHLYPAYMENT",
  SETDATACOLLECTIONFILTER: "SETDATACOLLECTIONFILTER",
  SETPICKUPMODALVISIBLE: "SETPICKUPMODALVISIBLE",
  SETPICKUPISPOLICIE: "SETPICKUPISPOLICIE",
  SETPRIMABANKTRANSFER: "SETPRIMABANKTRANSFER",
  SETHASPICKUP: "SETHASPICKUP",
  SETOVERYEARMODALVISIBLE: "SETOVERYEARMODALVISIBLE",
  SETRENEWTOKENRESULT: "SETRENEWTOKENRESULT",
  SETMORETHANAMONTHAWAY: "SETMORETHANAMONTHAWAY",
  SETCUSTOMERPAYMENTDATA: "SETCUSTOMERPAYMENTDATA",
  SET_INTERCOM_HASH: "SET_INTERCOM_HASH",
  GENERATE_INTERCOM_HASH: "GENERATE_INTERCOM_HASH",

  setMoreThanAMonthAway: (value) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.SETMORETHANAMONTHAWAY,
        value,
      });
    };
  },
  setSelectedCarsDT: (valor) => {
    return (dispatch) => {
      const carros_dterceros = valor;
      dispatch({
        type: segurosAction.CARROS_DTERCEROS,
        carros_dterceros,
      });
    };
  },
  setSelectedCyclesDT: (valor) => {
    return (dispatch) => {
      const motos_dterceros = valor;
      dispatch({
        type: segurosAction.MOTOS_DTERCEROS,
        motos_dterceros,
      });
    };
  },
  intercomlisto: (valor) => {
    return (dispatch) => {
      const intercomlisto = valor;
      dispatch({
        type: segurosAction.INTRERCOM_LISTO,
        intercomlisto,
      });
    };
  },
  selectCoberturaBasica: (valor) => {
    return (dispatch) => {
      const selectCobBasica = valor;
      dispatch({
        type: segurosAction.SELECT_COB_BASICA,
        selectCobBasica,
      });
    };
  },
  selectCedulaPasaporte: (valor) => {
    return (dispatch) => {
      const selectCedulaPas = valor;
      dispatch({
        type: segurosAction.CEDULA_PASAPORTE,
        selectCedulaPas,
      });
    };
  },
  setNotShowLanding: (valor) => {
    return (dispatch) => {
      const not_show_landing = valor;
      dispatch({
        type: segurosAction.NOT_SHOW_LANDING,
        not_show_landing,
      });
    };
  },
  selectCarroDatos: (valor) => {
    return (dispatch) => {
      const selectCarro = valor;
      dispatch({
        type: segurosAction.SELECT_CARRO,
        selectCarro,
      });
    };
  },
  tipoCobertura: (valor) => {
    return (dispatch) => {
      const tipoCobertura = valor;
      dispatch({
        type: segurosAction.TIPO_COBERTURA,
        tipoCobertura,
      });
    };
  },
  resquote: (valor) => {
    return (dispatch) => {
      const quotes = valor;
      dispatch({
        type: segurosAction.RES_QUOTE,
        quotes,
      });
    };
  },
  addquote: (valor) => {
    return (dispatch) => {
      const quotes = valor;
      // const quotes = [...getState().Todos.get('quotes'), newQuote];
      dispatch({
        type: segurosAction.ADD_QUOTE,
        quotes,
      });
    };
  },
  selseguro: (valor) => {
    return (dispatch) => {
      const selseguro = valor;
      dispatch({
        type: segurosAction.SEL_SEGURO,
        selseguro,
      });
    };
  },
  selsegurocc: (valor) => {
    return (dispatch) => {
      const selsegurocc = valor;
      dispatch({
        type: segurosAction.SEL_SEGURO_CC,
        selsegurocc,
      });
    };
  },
  limites: (valor) => {
    return (dispatch) => {
      const limites = valor;
      dispatch({
        type: segurosAction.SEL_LIMITES,
        limites,
      });
    };
  },
  selecciondeseguro: (valor) => {
    return (dispatch) => {
      const selecciondeseguro = valor;
      dispatch({
        type: segurosAction.SELECCION_SEGURO,
        selecciondeseguro,
      });
    };
  },
  convertirapdf: (valor) => {
    return (dispatch) => {
      const convertirapdf = valor;
      dispatch({
        type: segurosAction.CONVERTIR_PDF,
        convertirapdf,
      });
    };
  },
  selectseguro: (valor) => {
    return (dispatch) => {
      const selectseguro = valor;
      dispatch({
        type: segurosAction.SELECT_SEGURO_DT,
        selectseguro,
      });
    };
  },
  haseleccionadoseguro: (valor) => {
    return (dispatch) => {
      const haseleccionadoseguro = valor;
      dispatch({
        type: segurosAction.HASELECT_SEGURO_DT,
        haseleccionadoseguro,
      });
    };
  },
  edittodo: (editTodo) => {
    return (dispatch, getState) => {
      const oldTodos = getState().Todos.get("todos");
      const todos = [];
      oldTodos.forEach((todo) => {
        if (todo.id !== editTodo.id) {
          todos.push(todo);
        } else {
          todos.push(editTodo);
        }
      });
      dispatch({
        type: segurosAction.CHANGE_TODO,
        todos,
      });
    };
  },
  deleteTodo: (id) => {
    return (dispatch, getState) => {
      const oldTodos = getState().Todos.get("todos");
      const todos = [];
      oldTodos.forEach((todo) => {
        if (todo.id !== id) {
          todos.push(todo);
        }
      });
      dispatch({
        type: segurosAction.CHANGE_TODO,
        todos,
      });
    };
  },
  allCompleted: () => {
    return (dispatch, getState) => {
      const oldTodos = getState().Todos.get("todos");
      const todos = [];
      oldTodos.forEach((todo) => {
        todo.completed = true;
        todos.push(todo);
      });
      dispatch({
        type: segurosAction.CHANGE_TODO,
        todos,
      });
    };
  },
  deleteCompleted: () => {
    return (dispatch, getState) => {
      const oldTodos = getState().Todos.get("todos");
      const todos = [];
      oldTodos.forEach((todo) => {
        if (!todo.completed) {
          todos.push(todo);
        }
      });
      dispatch({
        type: segurosAction.CHANGE_TODO,
        todos,
      });
    };
  },
  setCurrentStep: (current_step) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.SET_CURRENT_STEP,
        current_step,
      });
    };
  },
  setAreInForm: (are_in_form) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.ARE_IN_FORM,
        are_in_form,
      });
    };
  },
  showSpinForm: (show_spin_form) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.SHOW_SPIN_FORM,
        show_spin_form,
      });
    };
  },
  setFormErrorMessage: (form_error_message) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.FORM_ERROR_MESSAGE,
        form_error_message,
      });
    };
  },
  allowPaymentSubmit: (allow_payment_submit) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.ALLOW_PAYMENT_SUBMIT,
        allow_payment_submit,
      });
    };
  },
  allowNextStepForm: (allow_next_step_form) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.ALLOW_NEXT_STEP_FORM,
        allow_next_step_form,
      });
    };
  },
  setStripFormCompleted: (stripe_form_completed) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.STRIPE_FORM_COMPLETED,
        stripe_form_completed,
      });
    };
  },
  setValidBornDate: (valid_borndate) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.VALID_BORNDATE,
        valid_borndate,
      });
    };
  },
  setCyberFormData: (cyber_form_data) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.CYBER_FORM_DATA,
        cyber_form_data,
      });
    };
  },
  setIndexLoaded: (index_loaded) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.INDEX_LOADED,
        index_loaded,
      });
    };
  },
  setContentLoaded: (content_loaded) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.CONTENT_LOADED,
        content_loaded,
      });
    };
  },
  setPaymentMade: (payment_made) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.PAYMENT_MADE,
        payment_made,
      });
    };
  },
  setDriverFormWithoutErrors: (driver_form_without_errors) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.DRIVER_FORM_WITHOUT_ERRORS,
        driver_form_without_errors,
      });
    };
  },
  setVehicleFormWithoutErrors: (vehicle_form_without_errors) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.VEHICLE_FORM_WITHOUT_ERRORS,
        vehicle_form_without_errors,
      });
    };
  },
  setDriverFormCompleted: (driver_form_completed) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.DRIVER_FORM_COMPLETED,
        driver_form_completed,
      });
    };
  },
  setDriverFormIDCompleted: (driver_form_id_completed) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.DRIVER_FORM_ID_COMPLETED,
        driver_form_id_completed,
      });
    };
  },
  setVehicleFormCompleted: (vehicle_form_completed) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.VEHICLE_FORM_COMPLETED,
        vehicle_form_completed,
      });
    };
  },
  setAllowCyberPayment: (allow_cyberpayment) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.allow_cyberpayment,
        allow_cyberpayment,
      });
    };
  },
  setCyberFormCompleted: (cyber_form_completed) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.CYBER_FORM_COMPLETED,
        cyber_form_completed,
      });
    };
  },
  setPayFormCompleted: (pay_form_completed) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.PAY_FORM_COMPLETED,
        pay_form_completed,
      });
    };
  },
  setBOTFormDriverCompleted: (bot_form_driver_completed) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.BOT_FORM_DRIVER_COMPLETED,
        bot_form_driver_completed,
      });
    };
  },
  setFCFormDriverCompleted: (fc_form_driver_completed) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.FC_FORM_DRIVER_COMPLETED,
        fc_form_driver_completed,
      });
    };
  },
  setBOTFormVehicleCompleted: (bot_form_vehicle_completed) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.BOT_FORM_VEHICLE_COMPLETED,
        bot_form_vehicle_completed,
      });
    };
  },
  setAreInBOTForm: (are_in_bot_form) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.ARE_IN_BOT_FORM,
        are_in_bot_form,
      });
    };
  },
  setPayCardType: (pay_card_type) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.PAY_CARD_TYPE,
        pay_card_type,
      });
    };
  },
  setCyberPostResponse: (cyber_post_response) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.CYBER_POST_RESPONSE,
        cyber_post_response,
      });
    };
  },
  setEmisionResponse: (emision_response) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.EMISION_RESPONSE,
        emision_response,
      });
    };
  },
  setEmisionErrorMessage: (emision_error_message) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.EMISION_ERROR_MESSAGE,
        emision_error_message,
      });
    };
  },
  startRequestCarsApi: (request_cars_api) => {
    let valor = request_cars_api ? request_cars_api : "valor_prueba";
    return (dispatch) => {
      dispatch({
        type: segurosAction.REQUEST_CARS_API,
        valor,
      });
    };
  },
  startRequestCyclesApi: (request_cycles_api) => {
    let valor = request_cycles_api ? request_cycles_api : "valor_prueba";
    return (dispatch) => {
      dispatch({
        type: segurosAction.REQUEST_CYCLES_API,
        valor,
      });
    };
  },
  startRequestUserIP: (request_user_ip) => {
    let valor = request_user_ip ? request_user_ip : "valor_prueba";
    return (dispatch) => {
      dispatch({
        type: segurosAction.REQUEST_USER_IP,
        valor,
      });
    };
  },
  setCarsApiData: (cars_api_data) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.CARS_API_DATA,
        cars_api_data,
      });
    };
  },
  setCyclesApiData: (cycles_api_data) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.CYCLES_API_DATA,
        cycles_api_data,
      });
    };
  },
  setUserIP: (user_ip) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.USER_IP,
        user_ip,
      });
    };
  },
  setExpressPaymentCyberFormData: (expresspayment_cyber_form_data) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.EXPRESSPAYMENT_CYBER_FORM_DATA,
        expresspayment_cyber_form_data,
      });
    };
  },
  setExpressPaymentFormCompleted: (express_payment_form_completed) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.EXPRESSPAYMENT_FORM_COMPLETED,
        express_payment_form_completed,
      });
    };
  },
  setExpressPaymentErrorMessage: (expresspayment_error_message) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.EXPRESSPAYMENT_ERROR_MESSAGE,
        expresspayment_error_message,
      });
    };
  },
  setExpressPaymentCyberPostResponse: (expresspayment_cyber_post_response) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.EXPRESSPAYMENT_CYBER_POST_RESPONSE,
        expresspayment_cyber_post_response,
      });
    };
  },
  setExpressPaymentUrlProps: (expresspayment_url_props) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.EXPRESSPAYMENT_URL_PROPS,
        expresspayment_url_props,
      });
    };
  },
  setExpressPaymentBackendResponse: (expresspayment_backend_response) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.EXPRESSPAYMENT_BACKEND_RESPONSE,
        expresspayment_backend_response,
      });
    };
  },
  saveExpressPaymentFullUrl: (expresspayment_full_url) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.EXPRESSPAYMENT_FULL_URL,
        expresspayment_full_url,
      });
    };
  },
  setHavePolicyPic: (have_policy_pic) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.HAVE_POLICY_PIC,
        have_policy_pic,
      });
    };
  },
  setExpiredFormFilled: (expired_form_filled) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.EXPIRED_FORM_FILLED,
        expired_form_filled,
      });
    };
  },
  setUnSupCardType: (unsup_card_type) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.UNSUP_CARD_TYPE,
        unsup_card_type,
      });
    };
  },
  setOverYearVehicle: (overyear_vehicle) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.OVERYEAR_VEHICLE,
        overyear_vehicle,
      });
    };
  },
  setAdBlockerDetected: (adblocker_detected) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.ADBLOCKER_DETECTED,
        adblocker_detected,
      });
    };
  },
  setShowHomePage: (show_homepage) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.SHOW_HOMEPAGE,
        show_homepage,
      });
    };
  },
  setBankTransferProcess: (bank_transfer_process) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.BANK_TRANSFER_PROCESS,
        bank_transfer_process,
      });
    };
  },
  setYappyTransferProcess: (yappy_transfer_process) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.YAPPY_TRANSFER_PROCESS,
        yappy_transfer_process,
      });
    };
  },
  setNotShowPopup: (not_show_popup) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.NOT_SHOW_POPUP,
        not_show_popup,
      });
    };
  },
  setReturnFromSameMode: (return_from_same_mode) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.RETURN_FROM_SAME_MODE,
        return_from_same_mode,
      });
    };
  },
  setCyclesLandingMode: (cycles_landing_mode) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.CYCLES_LANDING_MODE,
        cycles_landing_mode,
      });
    };
  },
  setCurrentReferrer: (current_referrer) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.CURRENT_REFERRER,
        current_referrer,
      });
    };
  },
  setReferredCode: (referred_code) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.REFERRED_CODE,
        referred_code,
      });
    };
  },
  fetchReferralQuote: (value) => {
    let linkId = value;
    return (dispatch) => {
      dispatch({
        type: segurosAction.FETCH_REFERRAL_QUOTE,
        linkId,
      });
    };
  },
  setReferralID: (referral_id) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.REFERRAL_ID,
        referral_id,
      });
    };
  },
  setEmisionWithSoapResponse: (emision_with_soap_response) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.EMISION_WITH_SOAP_RESPONSE,
        emision_with_soap_response,
      });
    };
  },
  setBOTFailFormCompleted: (bot_fail_form_completed) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.BOT_FAIL_FORM_COMPLETED,
        bot_fail_form_completed,
      });
    };
  },
  setBOTFailFormUserID: (bot_fail_form_user_id) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.BOT_FAIL_FORM_USER_ID,
        bot_fail_form_user_id,
      });
    };
  },
  setRenewUserID: (renew_user_id) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.RENEW_USER_ID,
        renew_user_id,
      });
    };
  },
  setDTCustomerDataStored: (dt_customer_data_stored) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.DT_CUSTOMER_DATA_STORED,
        dt_customer_data_stored,
      });
    };
  },
  setIsMoroso: (isMoroso) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.DT_CUSTOMER_IS_MOROSO,
        isMoroso,
      });
    };
  },
  setBOTFailFormEmisionResponse: (bot_fail_form_emision_response) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.BOT_FAIL_FORM_EMISION_RESPONSE,
        bot_fail_form_emision_response,
      });
    };
  },
  setWtsModalUsed: (wts_modal_used) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.WTS_MODAL_USED,
        wts_modal_used,
      });
    };
  },
  setBlacklistedUser: (blacklisted_user) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.BLACKLISTED_USER,
        blacklisted_user,
      });
    };
  },
  setYappyResponse: (yappy_response) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.YAPPY_RESPONSE,
        yappy_response,
      });
    };
  },
  setFirstStepReloaded: (first_step_reloaded) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.FIRST_STEP_RELOADED,
        first_step_reloaded,
      });
    };
  },
  setSelectedPolicy: (selected_policy) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.SELECTED_POLICY,
        selected_policy,
      });
    };
  },
  setRenewalPlan: (renewalPlan) => {

    console.log("renewal plan ", renewalPlan);

    return (dispatch) => {
      dispatch({
        type: segurosAction.DT_SET_RENEWAL_PLAN,
        renewalPlan,
      });
    };
  },
  setUseTokenization: (use_tokenization) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.DT_SET_USE_TOKENIZATION,
        use_tokenization,
      })
    }
  },
  setInsuranceMode: (insurance_mode) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.INSURANCE_MODE,
        insurance_mode,
      });
    };
  },
  setPaymentMonthlySkyp: (payment_monthly_skip) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.PAYMENT_MONTHLY_SKIP,
        payment_monthly_skip,
      })
    }
  },
  renewPolicyAction: (value) => {
    let transactionId = value;
    return (dispatch) => {
      dispatch({
        type: segurosAction.RENEW_POLICY,
        transactionId,
      });
    };
  },
  renewHasBeenCalled: (value) => {
    let renew_has_been_called = value
    return (dispatch) => {
      dispatch({
        type: segurosAction.RENEW_POLICY_HAS_BEEN_CALLED,
        renew_has_been_called,
      });
    };
  },
  setPoliciesModalVisible: (policies_modal_visible) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.POLICIES_MODAL_VISIBLE,
        policies_modal_visible,
      })
    }
  },
  setLoading: () => {
    return (dispatch) => {

      dispatch({
        type: segurosAction.SETLOADING
      });

      setTimeout(() => {
        dispatch({
          type: segurosAction.REMOVELOADING
        })
      }, 1000);
    }
  },
  setPolicieEmitedYappy: (value) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.SET_POLICIE_EMITED_YAPPY,
        value
      })
    }
  },
  setRenewalMonthlyPayment: (value) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.SETRENEWALMONTHLYPAYMENT,
        value
      })
    }
  },
  setDTMonthlyPayment: (value) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.SETDTMONTHLYPAYMENT,
        value
      })
    }
  },
  setDataCollectionFilter: (value) => {
    return (dispatch) => {
      dispatch({ 
        type: segurosAction.SETDATACOLLECTIONFILTER,
        value
      })
    }
  },
  setPickUpModalVisible: (value) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.SETPICKUPMODALVISIBLE,
        value
       })
    }
  },
  setPickUpISPolicie: (value) => {
    return (dispatch) => {
      dispatch({ 
        type: segurosAction.SETPICKUPISPOLICIE,
        value
      })
    }
  },
  setPrimaBankTransfer: (value) => {
    return (dispatch) => {
      dispatch({ 
        type: segurosAction.SETPRIMABANKTRANSFER,
        value
      })
    }
  },
  setHasPickUp: (value) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.SETHASPICKUP,
        value
      })
    }
  },
  setOverYearModalVisible: (value) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.SETOVERYEARMODALVISIBLE,
        value
      })
    }
  },
  setRenewTokenResult: (value) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.SETRENEWTOKENRESULT,
        value
      })
    }
  },
  setCustomerPaymentData: (value) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.SETCUSTOMERPAYMENTDATA, value
      })
    }
  },
  generateIntercomHash: (value) => {
    return (dispatch) => {
      dispatch({
        type: segurosAction.GENERATE_INTERCOM_HASH, value
      })
    }
  }
};
export default segurosAction;
